import { FunctionComponent, ReactNode } from 'react'
import type { GtmAttributes } from '../../../../domain/shared/types/gtm.types'

type ButtonProps = {
  onClick: () => void
  label: string
  icon: ReactNode
  disabled?: boolean
} & GtmAttributes

export const Button: FunctionComponent<ButtonProps> = ({
  onClick,
  label,
  icon,
  disabled = false,
  'data-gtm': dataGtm,
  'data-gtm-label': dataGtmLabel,
}) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className="bg-white rounded-full shadow-lg border border-gray-200 p-2 md:py-3 md:px-4 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex gap-2"
    data-gtm={dataGtm}
    data-gtm-label={dataGtmLabel}
  >
    {icon}
    <span className="hidden md:inline text-gray-700">{label}</span>
  </button>
)
